module.exports = __webpack_public_path__ + "static/img/dingzhi_bg.4382bdd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/customtrips/dingzhi_bg.png
// module id = u4jh
// module chunks = 1